import styled from "styled-components";

export const ProfileHeader = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 370px;
  gap: 12px;
  padding-top: 16px;
`;

export const ProfileHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const ProfileHeaderColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 1.6rem;
`;
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
  flex: 1;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    font-family: Figtree;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    max-width: 400px;
    font-family: Figtree;
    opacity: 0.6;
    margin-bottom: 24px;
  }
`;

export const Button = styled.button`
  display: flex;
  width: ${(props) => (props.$width ? "100%" : "180px")};
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: #fff;
  border: none;
  outline: none;

  color: #081120;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: scale(1.025);
  }

  &:active {
    transform: scale(0.975);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const NameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const Name = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.09px;
`;

export const ContentContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  padding-inline: 16px;
`;

export const PlanBadge = styled.div`
  display: flex;
  height: 14px;
  padding: 1.6px 6px;
  justify-content: center;
  align-items: center;
  gap: 1.6px;

  border-radius: 19px;
  background: #4d9dff;
`;

export const PlaceBadge = styled.div`
  display: flex;
  height: 14px;
  padding: 1.6px 6px;
  justify-content: center;
  align-items: center;
  gap: 1.6px;

  border-radius: 19px;
  background: linear-gradient(90deg, #dc8401 0%, #fb0 100%);
`;

export const Username = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.06px;

  opacity: 0.5;
`;
export const MedalImg = styled.img`
  pointer-events: none;
  user-select: none;
  width: 13px;
  height: 13px;
`;

export const ProfilePhoto = styled.img`
  width: 68px;
  height: 68px;
  flex-shrink: 0;
  border-radius: 68px;
`;
export const StatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
`;

export const Stats = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;

  color: #fff;
  font-family: Figtree;
  font-size: ${(p) => (p.$light ? "13px" : "14px")};
  font-weight: ${(p) => (p.$light ? "300" : "600")};
  opacity: ${(p) => (p.$light ? 0.5 : 1)};
  letter-spacing: 0.07px;
`;

export const Description = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.065px;
  opacity: 0.8;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const FollowButton = styled.button`
  display: flex;
  height: 38px;
  padding: 11px 24px 11px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;

  border-radius: 100px;
  border: ${(p) => (!p.$isFollowed ? "none" : "1px solid #345884")};
  background: ${(p) => (!p.$isFollowed ? "#fff" : "#142743")};
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

  color: ${(p) => (p.$isFollowed ? "#fff" : "#060e1a")};
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.07px;

  cursor: pointer;
  outline: none;
`;

export const ShareButton = styled.button`
  display: flex;
  height: 38px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;

  border-radius: 100px;
  border: 0.5px solid #345884;
  background: #142743;

  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.07px;

  cursor: pointer;
  outline: none;
`;

export const EmptyProfile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.07px;
  flex: 1;

  opacity: 0.5;
`;

export const Content = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  flex: 1;
  flex-direction: column;
  gap: 32px;
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.075px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 16px;
  margin-left: -7px;
  opacity: 0.5;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;

export const Title = styled.h1`
  color: #fff;
  font-family: Figtree;
  font-size: 26px;
  font-weight: 500;
  line-height: 150%; /* 30px */
  letter-spacing: -0.1px;
  white-space: nowrap;
  margin-bottom: 32px;
`;

export const Container = styled.div`
  /* max-width: 1440px; */
  width: 100%;
  margin: 0 auto;
  flex: 1;
`;

export const ProfileImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const ProfileImage = styled.img`
  display: block;
  width: 110px;
  height: 110px;
  aspect-ratio: 1/1;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
`;

export const UploadPhotoButton = styled.button`
  display: inline-flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -16.5px;
  gap: 16.5px;
  height: 33px;
  white-space: nowrap;

  border-radius: 100px;
  border: 1px solid #345884;
  background: #14274390;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.07px;

  cursor: pointer;
  outline: none;
`;

export const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 370px;
`;

export const Wrapper = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  align-self: stretch;

  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  height: 48px;
`;

export const Input = styled.input`
  display: flex;
  padding: 12px;
  align-items: flex-start;
  gap: 10px;
  height: 41px;
  align-self: stretch;

  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const Textarea = styled.textarea`
  display: flex;
  padding: 12px;
  gap: 10px;
  min-height: 96px;
  align-self: stretch;
  resize: vertical;

  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  line-height: 1.4;

  &:focus {
    outline: none;
  }
`;

export const CharCount = styled.span`
  align-self: flex-end;
  color: #fff;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 400;
  opacity: 0.5;
`;

export const Label = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DeleteIcon = styled.div`
  position: relative;
  cursor: pointer;
`;
